import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const AccountContext = createContext(null);

export function AccountProvider({ children }) {
  const { user } = useAuth();
  const [accounts, setAccounts] = useState([]);
  const [currentKey, setCurrentKey] = useState(localStorage.getItem("rl_account") || "");

  useEffect(() => {
    if (!user) return;
    api.get("/accounts").then(({ data }) => {
      setAccounts(data);
      const stored = localStorage.getItem("rl_account");
      const valid = data.find((a) => a.key === stored);
      const next = valid ? stored : data[0]?.key || "";
      setCurrentKey(next);
    });
  }, [user]);

  const switchAccount = (key) => {
    setCurrentKey(key);
    localStorage.setItem("rl_account", key);
  };

  const current = accounts.find((a) => a.key === currentKey) || accounts[0] || null;

  return (
    <AccountContext.Provider value={{ accounts, current, currentKey, switchAccount }}>
      {children}
    </AccountContext.Provider>
  );
}

export const useAccount = () => useContext(AccountContext);
